import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ServiceStock } from '../service-stock.service';
import { AccountsService } from '../services/accounts/accounts.service';
import { DepositService } from '../services/deposit.service';

@Component({
  selector: 'app-add-product',
  templateUrl: './add-product.component.html',
  styleUrls: ['./add-product.component.scss']
})
export class AddProductComponent implements OnInit {

  showWarning:boolean = false;
  isApplicationDataAvailable:boolean = false;

  stickerSlideConfig = {
    centerMode: false,
    centerPadding: '60px',
    slidesToShow: 1,
    dots: true,
    arrows: false,
    infinite: false,
    variableWidth: true,
    customPaging : function(slider, i) {
        return '<span></span>';
    },
  }

  constructor(public services:ServiceStock, 
    private _router:Router, 
    private _accountsService:AccountsService,
    private _depositService:DepositService) {
  }

  ngOnInit() {
  }

  onFetchDataDone(){
    this.services.hideSpinner();
    let obService = this.services.accountOnboarding;
    this.isApplicationDataAvailable = obService.isApplicationDataAvailable;
    if(this.isApplicationDataAvailable){
      this.showWarning = true;
    }else{
      this.services.router.navigate(['/accountOpening/newAccountTypes']);
    }
  }

  startAddProduct(){
    //this.services.showSpinner();
    //this.services.accountOnboarding.fetchDraftData(this.onFetchDataDone.bind(this));
  }

  closePopup(){
    this.services.router.navigate(['/home/overview']);
  }

  continue(){
    this.services.router.navigate(['/home/openAccount']);
  }

  gotoAccounts(){
    this.services.router.navigate(['/home/transactions']);
  }

  openNewAccount(account:string){
    let path:any = "";
    let menuId:any="";
    let menuItem:any;

    if(account == "current"){
      path = ["shell","accounts","open-new-current-account"];
      menuItem = this._accountsService.getSelectedMenuData("A008");
    } else if(account == "savings"){
      path = ["shell","accounts","open-new-savings-account"];
      menuItem = this._accountsService.getSelectedMenuData("A009");
    } else if(account == "deposit"){
      path = ["shell","deposits","open-new-deposit"];
      menuItem = this._depositService.getSelectedMenuData("D001");
    }

    this._router.navigate(path, { 
      queryParams: {}, 
      queryParamsHandling: "preserve",
      state: {
        "title" : menuItem.title,
        "serviceCode" : menuItem.serviceCode
      }
    });
  }

}
